import { render, staticRenderFns } from "./FieldFieldInfo.vue?vue&type=template&id=3d89afcd&scoped=true&"
import script from "./FieldFieldInfo.vue?vue&type=script&lang=js&"
export * from "./FieldFieldInfo.vue?vue&type=script&lang=js&"
import style0 from "./FieldFieldInfo.vue?vue&type=style&index=0&id=3d89afcd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d89afcd",
  null
  
)

export default component.exports